<template>
  <div style="position: relative;">
    <el-button
      type="primary"
      class="btnBack"
      size="small"
      @click="back"
    >
      &lt;&lt;返回课程管理
    </el-button>
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleTabClick"
    >
      <el-tab-pane
        label="课程信息"
        name="kechengxinxi"
      >
        <kechengxinxi
          :post-id="postId"
        />
      </el-tab-pane>
      <el-tab-pane
        label="完成单位"
        name="wanchengdanwei"
      >
        <wanchengdanwei
          :post-id="postId"
        />
      </el-tab-pane>
      <el-tab-pane
        label="附件"
        name="Appendix"
      >
        <Appendix />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import kechengxinxi from './kechengxinxi'
import wanchengdanwei from './wanchengdanwei'
import Appendix from '@/views/managesystem/gz/com/Appendix.vue'

export default {
  components: {
    kechengxinxi,
    wanchengdanwei,
    Appendix
  },
  data() {
    return {
      postId: '',
      moduleCode: '',
      activeName: 'kechengxinxi'
    }
  },
  created() {
    this.postId = this.$route.params.id
    this.moduleCode = 'jx01'
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    handleTabClick(tab, event) {
      // 附件
      if (tab.name === 'Appendix') {
        this.$bus.emit('handleInitAppendix')
      }
    }
  }
}
</script>
<style scoped>
.btnBack {
  position: absolute;
  right: 5px;
  top: 2px;
  z-index: 99;
}
</style>
